import * as React from 'react';
import { observer } from 'mobx-react';
import { AchPaymentMethodViewModel } from './ach-payment-method-view-model';
import { FormControl } from '../../components/form-control/form-control';
import { FormControlSplitButton, IFormControlSplitButtonOptions } from '../../components/split-button';
import { AchAccountType } from '../../webgiving-generated';
import { AccountNumberInput } from '../../components/account-number-input';
import { RoutingNumberInput } from '../../components/routing-number-input';
import { SvgIcon } from '../../components/svg-icon';
import { Text } from '../../components/text';

import routingNumberImage from '../../assets/svg/routing-number.svg';
import accountNumberImage from '../../assets/svg/account-number.svg';

import { imageContainer, image, imageActive, imageDescription } from './ach-payment-method.less';
import { Alert } from '../../components/alert/alert';

@observer
export class AchPaymentMethod extends React.Component<{ vm: AchPaymentMethodViewModel }, {}> {
	render () {
		const { routingNumber, accountNumber, accountType, routingNumberFocused, accountNumberFocused, accountMismatchError } = this.props.vm;
		const accountTypeOptions: IFormControlSplitButtonOptions<AchAccountType>[] = [{
			value: AchAccountType.Checking,
			label: 'Checking',
		}, {
			value: AchAccountType.Savings,
			label: 'Savings',
		}];
		const errorMessageContent = accountMismatchError ? <div><Text>Your account numbers do not match.</Text><br /><Text>Please enter your account number again.</Text></div> : null;
		const errorMessageId = 'ach-account-mismatch-error-message';

		return (
			<div data-pp-at-target="Enter ACH page">
				<Alert content={errorMessageContent} id={errorMessageId} />
				<div className={imageContainer}>
					<div className={`${image} ${routingNumberFocused ? imageActive : ''}`}>
						<SvgIcon svg={routingNumberImage} />
						<div className={imageDescription}><Text>Routing number</Text></div>
					</div>
					<div className={`${image} ${accountNumberFocused ? imageActive : ''}`}>
						<SvgIcon svg={accountNumberImage} />
						<div className={imageDescription}><Text>Account number</Text></div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
						<RoutingNumberInput
							value={routingNumber}
							formControlId="ach-routing-number"
							onFocus={this.handleRoutingNumberFocused}
							onBlur={this.handleRoutingNumberBlurred}
							focusOnMount={!accountMismatchError}
							acceptanceTestTargetId="ACH Routing Number"/>
					</div>
					<div className="col-sm-6">
						<AccountNumberInput
							value={accountNumber}
							formControlId="ach-account-number"
							label="Account number"
							onFocus={this.handleAccountNumberFocused}
							onBlur={this.handleAccountNumberBlurred}
							focusOnMount={accountMismatchError}
							labelledBy={errorMessageContent ? errorMessageId : undefined}
							acceptanceTestTargetId="ACH Account number"
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-6">
						<FormControl label="Account type" validationError={accountType.validationError}>
							<FormControlSplitButton field={accountType} options={accountTypeOptions} uniformWidth acceptanceTestTargetId="Account type" />
						</FormControl>
					</div>
				</div>
			</div>
		);
	}

	handleRoutingNumberFocused = () => this.props.vm.updateRoutingNumberFocused(true);

	handleRoutingNumberBlurred = () => {
		this.props.vm.updateRoutingNumberFocused(false);
		this.props.vm.routingNumber.revalidate();
	}

	handleAccountNumberFocused = () => this.props.vm.updateAccountNumberFocused(true);

	handleAccountNumberBlurred = () => {
		this.props.vm.updateAccountNumberFocused(false);
		this.props.vm.accountNumber.revalidate();
	}
}
